module.exports = __webpack_public_path__ + "static/media/grin-tongue-wink.8d7443bb.svg";